import Typography from '@components/typography'
import Column from '@components/column'
import Row from '@components/row'
import Circle from '@components/circle'
import Empty from '@commons/empty'
const Experiences = ({ experiences }) => {
  return (
    <Column
      bg={'white'}
      styleColumn="margin-top:20px;padding:20px;border-radius:8px;"
    >
      <Typography size={16} tc="primary" content="Experience" />
      <Column styleColumn="margin-top:20px;" rowGap={10}>
        {!!experiences?.length ? (
          <>
            {experiences?.map((experience) => {
              return (
                <Row colGap={10} alignItems="center" key={experience?.id}>
                  <Circle size={10} bg="secondary" />
                  <Typography
                    tc="text"
                    content={'2001 - Present Job role, Organization name'}
                    weight={400}
                  />
                </Row>
              )
            })}
          </>
        ) : (
          <Empty />
        )}
      </Column>
    </Column>
  )
}

export default Experiences
